<template>
  <!-- partial:../../partials/_sidebar.html -->
  <nav class="sidebar">
    <div class="sidebar-header">
      <a href="#" class="sidebar-brand"> i<span>PMS</span> </a>
      <div class="sidebar-toggler not-active">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="sidebar-body">
      <ul class="nav">
        <li class="nav-item nav-category">System Setup</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#system"
            role="button"
            aria-expanded="false"
            aria-controls="system"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="system">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link to="/system-setup/organizations" class="nav-link">
                  Organizations
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/system-setup/owners" class="nav-link">
                  Owners
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/system-setup/vessels" class="nav-link">
                  Vessels
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/system-setup/units" class="nav-link">
                  Units
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/system-setup/ports" class="nav-link">
                  Ports
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Safety Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#safety"
            role="button"
            aria-expanded="false"
            aria-controls="safety"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="safety">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link to="/values" class="nav-link">
                  Values
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/value-lists" class="nav-link">
                  Value Lists
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/value-list-details" class="nav-link">
                  Value List Details
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/report-types"
                  class="nav-link"
                >
                  Report Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/accident-types"
                  class="nav-link"
                >
                  Accident Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/accident-root-cause-types"
                  class="nav-link"
                >
                  Accident Root Cause Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/accident-preventive-action-categories"
                  class="nav-link"
                >
                  Accident Prevention Action Categories
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  to="/safety-management/near-miss-categories"
                  class="nav-link"
                >
                  Near Miss Categories
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/audit-types"
                  class="nav-link"
                >
                  Audit Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/internal-audit-types"
                  class="nav-link"
                >
                  Internal Audit Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/audit-categories"
                  class="nav-link"
                >
                  Audit Categories
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/drill-categories"
                  class="nav-link"
                >
                  Drill Categories
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  to="/safety-management/basis-of-car"
                  class="nav-link"
                >
                  Basis Of CAR
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/emergency-company-types"
                  class="nav-link"
                >
                  Emergency Company Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/master-handing-taking-over-checklist"
                  class="nav-link"
                >
                  Master Handing/Taking Over Checklist
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  to="/safety-management/officer-enginner-handing-taking-over-checklist"
                  class="nav-link"
                >
                  Officer & Engineer Handing/Taking Over Checklist
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/safety-meeting-agendas"
                  class="nav-link"
                >
                  Safety Meeting Agenda
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/masters-management-agendas"
                  class="nav-link"
                >
                  Masters Management Agenda
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/locations-on-board"
                  class="nav-link"
                >
                  Locations on Board
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/viq-numbers"
                  class="nav-link"
                >
                  VIQ Number
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/types-of-operations"
                  class="nav-link"
                >
                  Type of Operation
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/types-of-trainings"
                  class="nav-link"
                >
                  Type of Training
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/potential-incident-categories"
                  class="nav-link"
                >
                  Potential Incident Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/type-of-injuries"
                  class="nav-link"
                >
                  Type of injury
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/company-service-lines"
                  class="nav-link"
                >
                  Company / Service Line
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/category-oceaneering-cards"
                  class="nav-link"
                >
                  Category Oceaneering - Cards
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/high-hazard-task-observations"
                  class="nav-link"
                >
                  High Hazard Task Observation
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/observation-categories"
                  class="nav-link"
                >
                  Observation Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/evalution-types"
                  class="nav-link"
                >
                  Evaluation Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/syllabus-for-training-evalutions"
                  class="nav-link"
                >
                  Syllabus for Training Evaluation
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/nc-categories"
                  class="nav-link"
                >
                  NC Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/mnc-categories"
                  class="nav-link"
                >
                  MNC Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/injury-categories"
                  class="nav-link"
                >
                  Injury Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/main-observation-categories"
                  class="nav-link"
                >
                  Observation Category
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  to="/safety-management/vessel-certificate-categories"
                  class="nav-link"
                >
                  Vessel Certificate Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/safety-management/vessel-certificate-names"
                  class="nav-link"
                >
                  Vessel Certificate Names
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Procurement Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#procurement_management"
            role="button"
            aria-expanded="false"
            aria-controls="procurement_management"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="procurement_management">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/procurement-management/supplier-types"
                  class="nav-link"
                >
                  Supplier Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/requisition-natures"
                  class="nav-link"
                >
                  Requisition nature
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/invoice-discrepancy-reasons"
                  class="nav-link"
                >
                  Invoice Discrepancy Reason
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/expenses-categories"
                  class="nav-link"
                >
                  Expenses category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/buyers"
                  class="nav-link"
                >
                  Buyers
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/supplier-details"
                  class="nav-link"
                >
                  Supplier Details
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/approval-limits"
                  class="nav-link"
                >
                  Approval Limits
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/parent-account-code-groups"
                  class="nav-link"
                >
                  Parent Account Code Groups
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/parent-account-codes"
                  class="nav-link"
                >
                  Parent Account Codes
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/company-account-codes"
                  class="nav-link"
                >
                  Company Account Codes
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/owner-account-codes"
                  class="nav-link"
                >
                  Owner Account Codes
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/account-codes"
                  class="nav-link"
                >
                  Account Codes
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/owner-account-mappings"
                  class="nav-link"
                >
                  Owner Account Mappings
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/po-term-conditions"
                  class="nav-link"
                >
                  Po Term And Conditions
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/tax-setups"
                  class="nav-link"
                >
                  Taxes Setups
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <hr style="borader: solid black 2px" />
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#procurement_management_data"
            role="button"
            aria-expanded="false"
            aria-controls="procurement_management_data"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Data</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="procurement_management_data">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/procurement-management/requisitions"
                  class="nav-link"
                >
                  Requisitions
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/procurement-management/rfqs" class="nav-link">
                  RFQs
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/quotations"
                  class="nav-link"
                >
                  Quotations
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/purchase-orders"
                  class="nav-link"
                >
                  Purchase Orders
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/procurement-management/invoices"
                  class="nav-link"
                >
                  invoices
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Voyage Monitoring</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#charter"
            role="button"
            aria-expanded="false"
            aria-controls="charter"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="charter">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link to="/voyage-monitoring/charterer" class="nav-link">
                  Charterer
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/voyage-monitoring/directions"
                  class="nav-link"
                >
                  Directions
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/voyage-monitoring/fuel-consumption-lists"
                  class="nav-link"
                >
                  Fuel Consumption List
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/voyage-monitoring/running-hours-lists"
                  class="nav-link"
                >
                  Running Hours List
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/voyage-monitoring/consumption-types"
                  class="nav-link"
                >
                  Consumption Types
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Rest Hours Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#rest"
            role="button"
            aria-expanded="false"
            aria-controls="rest"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="rest">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/rest-hours-management/holidays-and-fixed-working-hours"
                  class="nav-link"
                >
                  Holidays and Fixed Working Hours
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/rest-hours-management/operations"
                  class="nav-link"
                >
                  Operations
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/rest-hours-management/rest-hour-settings"
                  class="nav-link"
                >
                  Rest Hour settings
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/rest-hours-management/crew-details"
                  class="nav-link"
                >
                  Crew Details
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/rest-hours-management/vessel-holiday-calendars"
                  class="nav-link"
                >
                  Vessel Holiday Calendars
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Planned Maintenance</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#planned"
            role="button"
            aria-expanded="false"
            aria-controls="planned"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="planned">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/main-machinery-groups"
                  class="nav-link"
                >
                  Main Machinery Groups
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/general-item-inventory-categories"
                  class="nav-link"
                >
                  General Item / Inventory category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/location-on-boards"
                  class="nav-link"
                >
                  Locations on Board
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/job-categories"
                  class="nav-link"
                >
                  Job Categories
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/class-survey-groups"
                  class="nav-link"
                >
                  Class Survey Groups
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/vessel-certificate-names"
                  class="nav-link"
                >
                  Vessel Certificate Names
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/vessel-certificate-categories"
                  class="nav-link"
                >
                  Vessel Certificate Category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/defect-categories"
                  class="nav-link"
                >
                  Defect category
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/inspection-groups"
                  class="nav-link"
                >
                  Inspection Groups
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/inspection-types"
                  class="nav-link"
                >
                  Inspection Types
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/postponement-reasons"
                  class="nav-link"
                >
                  Postponement Reason
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/reasons-for-pending"
                  class="nav-link"
                >
                  Reasons for pending
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/vessel-deficiency-root-causes"
                  class="nav-link"
                >
                  Vessel Deficiency Root Cause
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/machinary-details"
                  class="nav-link"
                >
                  Machinary Details
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/spare-parts"
                  class="nav-link"
                >
                  Spare Parts
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/general-item-inventories"
                  class="nav-link"
                >
                  General Items / Inventory
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/inspection-conditions"
                  class="nav-link"
                >
                  Inspection Conditions
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/miscellaneous-items"
                  class="nav-link"
                >
                  Miscellaneous Items
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <hr />
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#planned-data"
            role="button"
            aria-expanded="false"
            aria-controls="planned-data"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Data</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="planned-data">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/parameter-setups"
                  class="nav-link"
                >
                  Parameter Setups
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/parameter-monitorings"
                  class="nav-link"
                >
                  Parameter Monitoring
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/office-job-schedulers"
                  class="nav-link"
                >
                  Office Job Schedulers
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/class-recommendation-and-notes"
                  class="nav-link"
                >
                  Class Recommendation And Notes
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/planned-maintenance/vessel-certificates"
                  class="nav-link"
                >
                  Vessel Certificates
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Document Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#document"
            role="button"
            aria-expanded="false"
            aria-controls="document"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="document">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/document-management/categories"
                  class="nav-link"
                >
                  Categories
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <hr style="border: solid black 2px" />
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#Data"
            role="button"
            aria-expanded="false"
            aria-controls="Data"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Data</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="Data">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/document-management/new-documents"
                  class="nav-link"
                >
                  New Documents
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Form Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#form"
            role="button"
            aria-expanded="false"
            aria-controls="form"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="form">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link to="/form-management/categories" class="nav-link">
                  Categories
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <hr style="boder: solid black 2px" />
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#formData"
            role="button"
            aria-expanded="false"
            aria-controls="formData"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Data</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="formData">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link to="/form-management/Forms" class="nav-link">
                  Form
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item nav-category">Environment Management</li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            href="#environment"
            role="button"
            aria-expanded="false"
            aria-controls="environment"
          >
            <i class="link-icon" data-feather="settings"></i>
            <span class="link-title">Module Setup</span>
            <i class="link-arrow" data-feather="chevron-down"></i>
          </a>
          <div class="collapse" id="environment">
            <ul class="nav sub-menu">
              <li class="nav-item">
                <router-link
                  to="/environment-management/financial-year-quarters"
                  class="nav-link"
                >
                  Financial Year & Quarters
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  <!-- partial -->
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      // role: {}
    };
  },
  computed: {
    role() {
      let role = this.user.roles[0];
      return role;
    },
  },
  mounted() {
    // this.role = this.user.roles[0]
    // console.log(this.role)
  },
};
</script>
